$(function(){
  $(".js-current-link a") .each(function(){
    var $t = $(this);
    var href = $(this).attr("href");

    if( href == location.pathname || href == location.pathname + "index.html" ) {
      $t.addClass("is-current");

      var self = $t.parents(".footer__menu__li");
      self.toggleClass("is-active");
    }
  });
});



// WEBPACK FOOTER //
// ./_src/js/util/current.js